<template>
  <b-tab
    title="使用趨勢"
    v-bind:title-link-class="tabClass"
  >
    <div :id="id">
      <div v-if="debug">{{keywords}}</div>
      <h2 v-if="error">無資料</h2>
    </div>
  </b-tab>
</template>

<script>
//ref: https://codepen.io/Cleysense/pen/jeoMVq
import moment from "moment";
import Global from "@/components/Global.vue";

export default {
  name: "GoogleTrend",
  props: ["id", "keywords", "geo", "tabClass"],
  data: function() {
    return {
      error: false
    };
  },
  computed: {
    debug: function() {
      return Global.debug;
    }
  },
  mounted: function() {
    const keywords = this.keywords;
    const geo = this.geo ? this.geo : "TW";
    const nowTime = moment(new Date()).format("YYYY-MM-DD");
    const time = `2004-01-01 ${nowTime}`;
    let comparisonItems = [];

    try {
      for (let i = 0; i < keywords.length; i++) {
        comparisonItems.push({
          keyword: keywords[i],
          geo: geo,
          time: time
        });
      }
    } catch (e) {
      this.error = true;
      console.log(e);
    }

    //append embed script to head
    const script = document.createElement("script");
    script.src =
      "https://ssl.gstatic.com/trends_nrtr/3045_RC01/embed_loader.js";
    script.async = true;
    document.head.appendChild(script);

    //do further things after loaded
    script.onload = () => {
      var divElem = document.getElementById(this.id);

      trends.embed.renderExploreWidgetTo(
        divElem,
        "TIMESERIES",
        {
          comparisonItem: comparisonItems,
          category: 0,
          property: ""
        },
        {
          exploreQuery: `q=${keywords.join(",")}&date=all&geo=${geo}`,
          guestPath: "https://trends.google.com:443/trends/embed/"
        }
      );
    };
  }
};
</script>
